import { React } from "react";

import FormComponent from "../../components/Form";
import PageContainer from "../../components/PageContainer";
import PageHeaderContainer from "../../components/PageHeaderContainer";
import PageContentContainer from "../../components/PageContentContainer";
import CardComponent from "../../components/Card";
import { ContainerWithSidebar } from "../../components/ContainerWithSidebar";

import { FaWpforms } from "react-icons/fa";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function Formularios({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
  logOut,
}) {
  return (
    <ContainerWithSidebar
      increaseFontSize={increaseFontSize}
      decreaseFontSize={decreaseFontSize}
      HandledarkMode={HandledarkMode}
      isDarkMode={isDarkMode}
      logOut={logOut}
    >
      <PageContainer>
        <PageHeaderContainer title="Formulários" icon={<FaWpforms />} />
        <PageContentContainer>
          <Row>
            <Col>
              <h2>Formulários Bootstrap</h2>
              <hr />
              <p>
                Documentação formulários bootstrap{" "}
                <a href="https://react-bootstrap.netlify.app/docs/forms/overview/">
                  Formulários
                </a>
              </p>
              <p>
                Os formulários disponíveis pelo bootstrap já trazem um estilo
                adequado sendo necessário apenas realizar ajustes finos como
                alteração dos botões para o padrão de cores T2M. Existem
                componentes de formulários prontos, mas é possível construir uma
                estrutura personalizada através dos componentes individuais como
                Inputs, Select, Radio-button entre outros. Toda documentação
                pode ser conferida no próprio bootstrap.
              </p>
              <CardComponent
                title="Aviso!"
                subTitle="Importante!"
                bgColor="warning"
                textColor="black"
                size="100%"
              >
                <span className="d-flex flex-wrap gap-2 align-items-center">
                  Manter a ordem de apresentação dos botões, da esquerda para
                  direita
                  <span
                    style={{
                      backgroundColor: "#585859",
                      width: "10rem",
                      color: "#FFF",
                      textAlign: "center",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    Cancelar
                  </span>
                  e em seguida
                  <span
                    style={{
                      backgroundColor: "#03A688",
                      width: "10rem",
                      color: "#FFF",
                      textAlign: "center",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    Enviar
                  </span>
                </span>
              </CardComponent>
            </Col>
          </Row>
          <Row>
            <Col>
              <h2 className="mt-3">Exemplo de Layout</h2>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormComponent />
            </Col>
          </Row>
        </PageContentContainer>
      </PageContainer>
    </ContainerWithSidebar>
  );
}

export default Formularios;
